<template><div><TopBar><template #breadcrumb><span>ระบบหลังบ้าน / Facebook Auto Reply</span></template></TopBar><FacebookAutomationWorkbench :api="api" /></div></template>
<script>
import axios from 'axios';
import CacheHelper from '@/helper/CacheHelper';
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import FacebookAutomationWorkbench from '../component/FacebookAutomationWorkbench.vue';
const cache = new CacheHelper();
export default {
  components: { TopBar, FacebookAutomationWorkbench },
  methods: {
    async api(method, path, body) {
      const local = ['localhost', '127.0.0.1'].includes(window.location.hostname);
      const base = local ? 'http://localhost:8090' : process.env.VUE_APP_API_BASE_URL;
      const token = cache.getCache('auth')?.accessToken || '';
      const { data } = await axios({ method, url: `${base}/api/facebook-automation${path}`, data: body, headers: { Authorization: `Bearer ${token}` } });
      return data;
    },
  },
};
</script>
